import { useQuery } from '@tanstack/react-query';

import useApi from '../use-api';

import type {
  ISmsResponsesFilters,
  ISmsCampaignSummaryData,
} from 'infrastructure/interfaces';

const apiUrl = 'core-2/patients/sms-campaign/summary';

export const useSmsCampaignsSummaryData = (filters: ISmsResponsesFilters) => {
  const queryKey = [apiUrl, filters] as const;

  const { loadData } = useApi();

  const { data, error, isLoading, isPreviousData } = useQuery({
    queryKey,
    keepPreviousData: true,
    queryFn: async () => {
      const res = await loadData<ISmsCampaignSummaryData, ISmsResponsesFilters>(
        apiUrl,
        filters,
      );
      return res;
    },
    enabled: Boolean(filters.campaignGuid),
  });

  return {
    data: {
      data: data?.data ?? [],
    },
    isLoading: isLoading || isPreviousData,
    error,
    isPreviousData,
  };
};
